import {Component, OnDestroy, OnInit} from '@angular/core';
import 'rxjs/add/operator/catch';
import {Subscription} from 'rxjs/Subscription';
import {Auth} from '../../auth/auth.service';
import {MessengerService} from '../../messenger/messenger.service';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';
import {Comment} from '../classes/comment';

@Component({
    selector: 'kkk-comment',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit, OnDestroy {
    pending = false;
    showNewCommentForm = false;
    newComment: Comment;
    comments: Comment[];

    private _subscriptions: Subscription[] = [];

    constructor(
        public auth: Auth,
        private _breadcrumbs: BreadcrumbsService,
        private _messenger: MessengerService,
    ) {
    }

    ngOnDestroy() {
        this._subscriptions.forEach(s => s && s.unsubscribe());
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Kik vagyunk?', instructions: ['/kik-vagyunk']}).add({name: 'Hozzászólások'});
        this.resetForm();
        this.loadComments();
    }

    showForm() {
        this.showNewCommentForm = true;
    }

    save() {
        if (!this.newComment.text || this.newComment.text.length < 10) {
            this._messenger.showWarning('A hozzászólás szövegének legalább 10 karakter hosszúnak kell lennie!');
            return;
        }
        this.pending = true;
        this._subscriptions.push(
            this.newComment.save().subscribe(
                () => {
                    this.pending = false;
                    this._messenger.showSuccess('A hozzászólás sikeresen hozzáadva. Megjelenítése a moderátoron múlik.');
                    this.resetForm();
                },
                e => {
                    this._messenger.handleError(e);
                    this.pending = false;
                }
            )
        );
    }

    removeComment(comment: Comment): void {
        if (confirm('Biztosan törölni szeretnéd a hozzászólást?')) {
            this._subscriptions.push(comment.remove().subscribe(
                () => {
                    this._messenger.showSuccess('A hozzászólás törölve lett.');
                    this.comments = this.comments.filter(c => c !== comment);
                },
                this._messenger.handleError
            ));
        }
    }

    private loadComments() {
        this._subscriptions.push(
            new Comment().all()
                .catch(e => {
                    this._messenger.handleError(e);
                    return [];
                })
                .subscribe(
                    comments => this.comments = comments
                )
        );
    }

    private resetForm() {
        this.showNewCommentForm = false;
        this.newComment = new Comment();
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/comment/comment.component.ts